// SALDP white-labelling. Added by Sullivan Digital, 2026-10-26. Licensed under the GNU AGPL v3; see LICENSE-AGPL.txt.

/**
 * Whether `href` points at metabase.com, one of its subdomains, or the
 * metaba.se link shortener, or mails a metabase.com address. This fork never
 * links users to Metabase: docs, learn, help, community, store, support.
 * Licence terms (`/license/...`) are legal notices and stay linked, so admins
 * can read the embedding licence they are asked to accept.
 */
export function isMetabaseComUrl(href: string | undefined | null): boolean {
  if (!href) {
    return false;
  }
  if (href.toLowerCase().startsWith("mailto:")) {
    return /@([a-z0-9-]+\.)*metabase\.com\b/i.test(href);
  }
  try {
    const { hostname, pathname } = new URL(href, "https://relative.invalid");
    const isMetabaseHost =
      hostname === "metabase.com" ||
      hostname.endsWith(".metabase.com") ||
      hostname === "metaba.se";
    return isMetabaseHost && !pathname.startsWith("/license");
  } catch {
    return false;
  }
}
